import React from "react";
import "./ProductDetails.css"; // Ümumi CSS fayl

function CatDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    const getStatus = (val) => val === true ? "Bəli" : val === false ? "Xeyr" : "Bilinmir";

    return (
        <div className="product-details">
            <h3 className="product-details-title">Pişik Məlumatları</h3>
            <div className="product-details-grid">
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Ad:</strong> {product.name || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Cins:</strong> {product.catBreed || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Yaş:</strong> {product.age ? `${product.age} yaş` : "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Cinsiyyət:</strong> {product.gender || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Çəki:</strong> {product.weight ? `${product.weight} kq` : "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Rəng:</strong> {product.color || "Bilinmir"}</div>
                </div>
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Sağlamlıq vəziyyəti:</strong> {product.healthStatus || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Peyvəndlər:</strong> {getStatus(product.vaccinated)}</div>
                    <div className="product-details-item"><strong>Şəcərə:</strong> {getStatus(product.pedigree)}</div>
                    <div className="product-details-item"><strong>Aksesuarlar daxildir:</strong> {getStatus(product.includesAccessories)}</div>
                    <div className="product-details-item"><strong>Şəhər:</strong> {product.city || "Bilinmir"}</div>
                </div>
            </div>

            {product.description && (
                <div className="product-description">
                    <strong>Əlavə təsvir:</strong>
                    <p>{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default CatDetails;
